// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"394afadb","238":"cf961dfc","313":"2a514d51","453":"d972d0e8","469":"e443f9fc","920":"3203f750"}[chunkId] + ".chunk.js";
};